module.exports = __webpack_public_path__ + "img/qr_code.63020236.png";